import { IonContent, IonIcon, IonModal } from "@ionic/react";
import { checkmark } from "ionicons/icons";
import { Toolbar } from "./Toolbar";
import { MinPriceProgressBarContent } from "./MinPriceProgressBarCard";
import { Card } from "@greeter/matter-v2";

import css from "./EditTablesModal.module.scss";

export type EditTablesModal = {
  isOpen?: boolean;
  onBack?: () => void;

  minPrice: number;
  currentTotal: number;

  slots?: {
    BookTableBox?: React.ReactNode;
  };
};

export function EditTablesModal(props: EditTablesModal) {
  return (
    <IonModal isOpen={props.isOpen} onWillDismiss={props.onBack}>
      <Toolbar.Container style={{ position: "sticky" }}>
        <Toolbar title="Skift borde" onBack={props.onBack} />
      </Toolbar.Container>
      <IonContent>
        <div
          style={{
            height: "fit-content",
            paddingBottom: "var(--facebook-padding, 0px)",
          }}
        >
          <div className={css.Container}>
            <div style={{ margin: "20px 0" }}>
              <MinPriceProgressBarContent
                target={props.minPrice}
                value={props.currentTotal}
              />
            </div>
            {props.slots?.BookTableBox}
          </div>
          <div className={css.BottomBar}>
            <div className={css.Content}>
              <Card
                act="button"
                variant="green"
                style={{ width: "100%" }}
                onClick={props.onBack}
              >
                <Card.Content preset="flex-aligned-center">
                  <IonIcon icon={checkmark} style={{ strokeWidth: 2 }} />
                  Godkend
                </Card.Content>
              </Card>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
}
